import { ApiClient } from "../../api-client";
import { ApiClientError } from "../../errors";
import schemaValidators from "./schema-validators";
export default class stateClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	get = async (uuid: string) => {
		try {
			const response = await super.fetch(new URL(`${this.config.verityOrigin}/api/verity/quiz/state/${uuid}`), {
				credentials: "include",
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.proctoringSessionState.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	set = async (uuid: string, status: string) => {
		try {
			const response = await super.fetch(new URL(`${this.config.verityOrigin}/api/verity/quiz/state/${uuid}`), {
				headers: {
					"Content-Type": "application/json",
				},
				method: "POST",
				credentials: "include",
				body: JSON.stringify({
					status,
				}),
			});
			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.proctoringSessionState.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
